<div *ngIf="value || showZeroValue"
     [class.is-negative]="isNegativeNumber(value)">
    {{formatCurrency(getAbs(value))}}
</div>
<div class="is-empty" style="text-align: center" *ngIf="!value && !showZeroValue"></div>
